<template>
  <div class="account">
    <div class="top-operation">
      <el-button @click="newDataHandle" type="primary">新增账号</el-button>
    </div>
    <el-form :model="searchForm" ref="form" :inline="true">
      <el-row :gutter="10">
        <el-col :span="4" class="row-item">
          <el-form-item>
            <el-select v-model="searchForm.platform" placeholder="请选择平台" style="width:100%;" @change="onSearchHandler">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in platformList" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-input v-model="searchForm.username" placeholder="请输入登录账号" @keyup.enter.native="onSearchHandler"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-input v-model="searchForm.name" placeholder="请输入真实姓名" @keyup.enter.native="onSearchHandler"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item>
            <el-button type="primary" @click="onSearchHandler">搜索</el-button>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="id" label="ID" align="center" width="100"></el-table-column>
      <el-table-column prop="username" label="登录账号" align="right"></el-table-column>
      <el-table-column prop="name" label="姓名" align="right"></el-table-column>
      <el-table-column label="邮件发送状态" align="right">
        <template slot-scope="scope">
          <p v-if="scope.row.isSuccessSendEmail == 0">发送失败</p>
          <p v-if="scope.row.isSuccessSendEmail == 1">发送成功</p>
        </template>
      </el-table-column>
      <el-table-column label="账号类型" align="right">
        <template slot-scope="scope">
          <p v-if="scope.row.platformDict">{{scope.row.platformDict.label}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="rolesStr" label="所属角色" align="right"></el-table-column>
      <el-table-column prop="lastLoginTime" label="最后登录时间" width="180" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.lastLoginTime | formatDate}}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="editRow(scope.row)">编辑</el-button>
          <el-button size="mini" @click="resetPassword(scope.row)">重置密码</el-button>
          <el-button size="mini" type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <table-pagination :pageTotal="tableTotal" @handlePageChange="handlePageChange" />
    <account-modal ref="accountModal" @loadData="loadData" :platformList="platformList"></account-modal>
  </div>
</template>

<script>
import AccountService from '@/services/system/account';
import AccountModal from './components/AccountModal';
import DictService from '@/services/system/dict';
export default {
  data () {
    return {
      tableData: [],
      tableTotal: 0,
      searchForm: {
        username: '',
        name: '',
        platform: '',
      },
      platformList: [],
    }
  },
  methods: {
    async initAccountList (params) {
      const { code, message, result: { data, total } } = await AccountService.accountListApi(params);
      if (Object.is(code, 0)) {
        this.tableData = data.map(item => {
          return {
            ...item,
            rolesStr: item.roles.map((item) => item.title).join(',')
          }
        });
        this.tableTotal = total;
      } else {
        console.error('获取账号失败', message);
      }
    },
    // 获取平台
    async initPlatform () {
      const { code, message, result } = await DictService.dictByTypeApi({ category: 'platform' });
      if (Object.is(code, 0)) {
        this.platformList = result;
      } else {
        console.log(message);
      }
    },
    // 搜索
    onSearchHandler () {
      this.initAccountList(this.searchForm);
    },
    // 分页
    handlePageChange (val) {
      this.initAccountList({ ...this.searchForm, pageNumber: val });
    },
    // 新增数据
    newDataHandle () {
      this.$refs.accountModal.openModal();
    },
    loadData () {
      this.initAccountList();
    },
    // 编辑行
    editRow (rowData) {
      this.$refs.accountModal.openModal(rowData);
    },
    // 重置密码
    resetPassword (rowData) {
      console.log(rowData);
      this.$confirm('是否将密码重置为: dancebox&123', {
        type: 'warning'
      }).then(async () => {
        const { code, message } = await AccountService.resetPasswordApi(rowData.id);
        if (Object.is(code, 0)) {
          this.$message.success(message);
        } else {
          this.$message.error(message);
        }
      }).catch(e => {
        console.log(e);
      })
    },
    // 删除
    deleteRow (rowData) {
      this.$confirm('确认删除？', {
        type: 'warning'
      }).then(async () => {
        const { code, message } = await AccountService.deleteAccountApi(rowData.id);
        if (Object.is(code, 0)) {
          this.$message.success(message);
          this.initAccountList();
        } else {
          this.$message.error(message);
        }
      }).catch(e => {
        console.log(e);
      })
    },
  },
  mounted () {
    this.initAccountList();
    this.initPlatform();
  },
  components: {
    AccountModal,
  }
}
</script>

<style lang="scss" scoped>
.row-item {
  ::v-deep .el-form-item {
    display: flex;
    flex-direction: row;
  }
  ::v-deep .el-form-item__label {
    width: 130px !important;
  }
}
</style>